import React from 'react';
import ReactDOM from 'react-dom';

import App from 'Containers/App';

import { initNotificationsSdk, initServiceWorker } from 'Utils/pwa';

import { initHotJar } from './utils/hotjar';
import { initDatadogLogs, initDatadogRum } from './utils/datadog';

import 'Styles/_main.scss';

initHotJar(1901552, 6);
initDatadogLogs();
initDatadogRum();

ReactDOM.render(<App />, document.getElementById('root'));

initNotificationsSdk();
initServiceWorker();
